import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatTabGroup } from '@angular/material/tabs';

// import { FactoryService } from '@FactoryServices/factory.service';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';

@Component({
    selector: 'app-factory-gui',
    templateUrl: './factory-gui.component.html',
    styleUrls: ['./factory-gui.component.css'],
    standalone: false
})
export class FactoryGuiComponent implements OnInit {
  title = 'factory-service-gui';

  factoryPanelDisabled = true;

  factoryJobId = '';
  jobNm = '';
  origFacilityCd = '';
  activeFlg = '';
  recordAddDt = '';
  dateLabel = '';

  jobIdControl = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern('[a-zA-Z0-9]*'),
  ]);

  constructor(
    // private factoryService: FactoryService,
    private efsApiService: EfsApiService,
    private apiErrorhandlingService: ApiErrorHandlingService,
  ) { }

  ngOnInit(): void {

  }

  // services
  serviceGetJobId(facilityCd) {
    this.efsApiService.getJobId(facilityCd).subscribe((data: any) => {
      console.log(JSON.stringify(data));
      this.factoryJobId = data.factoryJobId;
      this.jobNm = data.jobNm;
      this.origFacilityCd = data.origFacilityCd;
      this.activeFlg = data.activeFlg;
      this.recordAddDt = data.recordAddDt;
      this.dateLabel = this.humanReadableDate(data.recordAddDt);

      this.factoryPanelDisabled = false;
    });
  }

  serviceCancelJobId(jobId, jobName, facilityCd) {
    this.efsApiService.cancelJob(jobId, jobName, facilityCd).subscribe((data: any) => {
      console.log(JSON.stringify(data));

    });
  }

  // end of services

  getJobIdButton() {
    if (this.jobIdControl.status === 'VALID') {
      this.serviceGetJobId(this.jobIdControl.value);
    }
  }

  cancelJobButton() {
    this.serviceCancelJobId(this.factoryJobId, this.jobNm, this.origFacilityCd);
  }

  // date transformation methods
  humanReadableDate(date) {
    if (date === null || date === '') {
      return '';
    }
    console.log(date);
    date = (date as string).slice(0, 8);
    date = (date as string).slice(0, 2) + // rebuild the date in a human readable format
      '/' + (date as string).slice(2, 4) +
      '/' + (date as string).slice(4, 8);

    console.log(date);
    return date;
  }

  humanReadableToDatabase(date: string) { // convert a human readable date to a database stored type
    date = date.replace(/\//gm, '');
    date += '000000';
    console.log(date);
    if (date === '000000' || date === null || date === 'null') { // no date provided
      return '';
    } else {
      return date;
    }
  }

  transformDate(controlDate) { // transform date from control full style date to database style date
    const date: Date = controlDate;
    let dateString = ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + date.getFullYear();
    dateString = dateString + '000000';
    console.log('DATE IS ' + dateString);
    if (dateString === 'aNaNNaN000000' || dateString === '000000') { // received no date
      return '';
    } else {
      return dateString;
    }
  }


}
